import React, { useState, useEffect } from "react";
import { IonItem, IonDatetime, IonIcon } from "@ionic/react";
import dayjs from "dayjs";

import "./datepicker-component.scss";
import { utilService } from "../../../services/utilService";
import { calendarOutline } from "ionicons/icons";
import classNames from "classnames/bind";
import _ from "lodash";
import { useToast } from "@agney/ir-toast";
import { t } from "i18next";
/**
 * Date-picker component
 * Component will show a popup to select the date, month and year.
 * Component will return the date in the format 'YYYY-MM-DD'.
 */

interface DatePickerProps {
  getSelectedDate: (value: string) => void;
  isDateShort?: boolean;
  showCalendarIcon?: boolean;
  dateFromParent?: string;
  favCardData?: any;
  isFromEMS?: any;
  onClick?: any;
  teamEndDate?: any;
  teamLinkUser?: any;
  isDOB?: any;
  selectionUpdate?: any;
  isFromTeamCreation?: any;
}

const DatePickerComponent: React.FC<DatePickerProps> = (props) => {
  const today = utilService.getCurrentDate();
  let [selectedDate, setSelectedDate] = useState(today);
  interface dateStructure {
    day: { value: number };
    month: { value: number };
    year: { value: number };
  }
  const Toast = useToast();

  useEffect(() => {
    props.getSelectedDate(props.dateFromParent ? props.dateFromParent : today);
    setSelectedDate(props.dateFromParent ? props.dateFromParent : today);
  }, []);

  useEffect(() => {
    setDateForFavCard();
  }, [props.favCardData]);

  useEffect(() => {
    props.getSelectedDate(props.dateFromParent ? props.dateFromParent : today);
    setSelectedDate(props.dateFromParent ? props.dateFromParent : today);
  }, [props.dateFromParent]);

  useEffect(() => {}, [selectedDate]);

  const setDateForFavCard = () => {
    if (!_.isEmpty(props.favCardData)) {
      props.getSelectedDate(props.favCardData.params.date);
      setSelectedDate(props.favCardData.params.date);
    } else {
      props.getSelectedDate(
        props.dateFromParent ? props.dateFromParent : today
      );
      setSelectedDate(props.dateFromParent ? props.dateFromParent : today);
    }
  };

  const handleChange = (result: any) => {
    if (props.teamLinkUser) {
      let validateTime = validateSelectedDate(result);
      if (validateTime) {
        const selectedDateRes = dayjs(result).format("YYYY-MM-DD");
        if (selectedDateRes !== selectedDate) {
          props.getSelectedDate(result);
          setSelectedDate(selectedDateRes);
        }
      } else {
        props.getSelectedDate(props.teamEndDate);
        setSelectedDate(props.teamEndDate);
      }
    } else {
      const selectedDateRes = dayjs(result).format("YYYY-MM-DD");
      if (selectedDateRes !== selectedDate) {
        props.getSelectedDate(result);
        setSelectedDate(selectedDateRes);
      }
    }
  };

  const validateSelectedDate = (selectedDate: any) => {
    const selectedDateRes = dayjs(selectedDate).format("YYYY-MM-DD");
    return true;
  };

  return (
    <IonItem lines="none">
      <span
        className={classNames({
          "date-picker-cont": props.showCalendarIcon,
          "date-time-wrapper": true,
        })}
      >
        <IonDatetime
          presentation="date"
          color="aqua"
          display-format={
            props.isDateShort
              ? utilService.dateFormat("short")
              : utilService.dateFormat("long")
          }
          min={props.isDateShort ? today : "1900"}
          max={props.isDOB ? today : "2050"}
          value={props.isFromTeamCreation ? props.dateFromParent : selectedDate}
          cancelText={t("cancel")}
          doneText="OK"
          onIonChange={(e) => handleChange(e.detail.value!)}
        ></IonDatetime>

        {props.showCalendarIcon && (
          <IonIcon
            className={classNames({
              "calendar-icon": props.showCalendarIcon,
            })}
            icon={calendarOutline}
          />
        )}
      </span>
    </IonItem>
  );
};

export default DatePickerComponent;
